import { createElement } from "react";
import { Button } from 'antd';
const GrtExampleButtonFc = function (props) {
    return (<Button type={props.type}>{props.type}</Button>);
};
export default GrtExampleButtonFc;
